@if (user$ | async) {
  <router-outlet></router-outlet>
}
